import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';

const getLatestSelectedNodeId = (state: State): any => state.latestSelectedNodeId;

export const selectLatestSelectedNodeId: MemoizedSelector<
  object,
  any
  > = createSelector(selectBpmnProcessState, getLatestSelectedNodeId);
